import { ProjectChangesDateLogList } from '../../../domain/projectChangesDateLog/ProjectChangesDateLogList';
import { ProjectChangesListDTO } from '../../http/dtos/project-changes-date-log/projectChangesListDTO';

export const getProjectChangesDateLogListAdapter = (
    responseAPI: ProjectChangesListDTO[]
): ProjectChangesDateLogList[] => {
    return responseAPI
        ? responseAPI.map((projectChanges) => {
              return {
                  id: projectChanges.id,
                  newDate: projectChanges.newDate,
                  comments: projectChanges.comments,
                  noveltyType: projectChanges.noveltyType,
                  previousDate: projectChanges.previousDate,
                  date: projectChanges.date,
                  projectStatusId: projectChanges.projectStatusId,
                  ProjectStatusName: projectChanges.projectStatusName,
                  url: projectChanges.url,
              };
          })
        : [];
};
